import {BehaviorSubject} from 'rxjs';
import {Injectable} from '@angular/core';
import {filter, take} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class AuthStateService {
    private ready$ = new BehaviorSubject<boolean>(false);

    markReady() {
        this.ready$.next(true);
    }

    waitUntilReady() {
        return this.ready$.pipe(
            filter(v => v),
            take(1)
        );
    }
}
